<section class="text-center">
  <h3 class="mt-2 text-lg">Difesa e sostegno in caso di ritiro patente</h3>
  <p class="mt-2 mb-6">
    Non è possibile assicurare i titolari di ditte individuali,
    studi professionali e imprese familiari, <strong>ma solo i dipendenti</strong>.
  </p>
</section>

<section class="mt-10">
  <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
    <!-- Box 1: Difendi i tuoi diritti -->
    <article class="p-6 bg-white rounded-2xl border border-blue-900 text-center">
      <div class="flex justify-center mb-4" aria-hidden="true">
        <svg class="w-12 h-12 text-blue-700" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/>
          <path d="m9 12 2 2 4-4"/>
        </svg>
      </div>
      <h3 class="font-semibold text-lg text-gray-900">Difendi i tuoi diritti</h3>
      <p class="mt-2 text-sm text-gray-600">
        Tutela legale completa in caso di ritiro o sospensione della patente.
      </p>
    </article>

    <!-- Box 2: Network di avvocati -->
    <article class="p-6 bg-white rounded-2xl border border-blue-900 text-center">
      <div class="flex justify-center mb-4" aria-hidden="true">
        <svg class="w-12 h-12 text-blue-700" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 21h18"/>
          <path d="M12 3v18"/>
          <path d="M7 7h10"/>
          <path d="m17 7 4 6H13l4-6Z"/>
          <path d="m7 7-4 6h8L7 7Z"/>
        </svg>
      </div>
      <h3 class="font-semibold text-lg text-gray-900">Network di avvocati</h3>
      <p class="mt-2 text-sm text-gray-600">
        Assistenza immediata grazie a una rete di professionisti qualificati.
      </p>
    </article>

    <!-- Box 3: Copertura globale -->
    <article class="p-6 bg-white rounded-2xl border border-blue-900 text-center">
      <div class="flex justify-center mb-4" aria-hidden="true">
        <svg class="w-12 h-12 text-blue-700" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="M2 12h20"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z"/>
        </svg>
      </div>
      <h3 class="font-semibold text-lg text-gray-900">Copertura globale</h3>
      <p class="mt-2 text-sm text-gray-600">
        Valida anche all’estero per garantire serenità alla tua azienda.
      </p>
    </article>

    <!-- Box 4: Sostegno economico -->
    <article class="p-6 bg-white rounded-2xl border border-blue-900 text-center">
      <div class="flex justify-center mb-4" aria-hidden="true">
        <svg class="w-12 h-12 text-blue-700" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 7H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z"/>
          <path d="M16 7V5a2 2 0 0 0-2-2H5"/>
          <path d="M18 12h.01"/>
        </svg>
      </div>
      <h3 class="font-semibold text-lg text-gray-900">Sostegno economico</h3>
      <p class="mt-2 text-sm text-gray-600">
        Diaria fino a <span class="font-semibold">€250/giorno</span> per i giorni senza patente.
      </p>
    </article>
  </div>
</section>

<!-- Sezione: Questionario di adeguatezza -->
<section class="mt-12 text-center">
  <h2 class="text-xl font-semibold">Calcola il tuo preventivo ora</h2>
  <p class="mt-2">Bastano pochi passaggi per ottenere il tuo preventivo. Compila la domanda seguente per proseguire:</p>
  <p class="mt-4 text-gray-700">
    Hai già una copertura di tutela legale per gli stessi rischi legati alla sospensione della patente
    di un collaboratore d'azienda?
  </p>

  <fieldset class="mt-4">
    <legend class="sr-only">Copertura esistente</legend>
    <div class="flex items-center justify-center gap-8">
      <label class="inline-flex items-center gap-2 cursor-pointer">
        <input
          type="radio"
          name="copertura_esistente"
          value="si"
          [(ngModel)]="questionario.copertura_esistente"
          class="accent-blue-900"
        />
        <span>Sì</span>
      </label>

      <label class="inline-flex items-center gap-2 cursor-pointer">
        <input
          type="radio"
          name="copertura_esistente"
          value="no"
          [(ngModel)]="questionario.copertura_esistente"
          class="accent-blue-900"
        />
        <span>No</span>
      </label>
    </div>
  </fieldset>

  <!-- Messaggio d’errore -->
  <div
    *ngIf="showErrorMessage()"
    class="mt-6 mx-auto max-w-2xl rounded-lg border border-red-200 bg-red-50 p-4 text-red-700"
  >
    <p class="font-semibold">Non è possibile procedere con il preventivo.</p>
    <p>Contatta un nostro broker per maggiori informazioni.</p>
  </div>

  <!-- CTA -->
  <div class="mt-8 flex items-center justify-center">
    <button
        class="bg-blue-600 text-white font-semibold px-4 py-2 rounded shadow hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="avantiStep()"
        [disabled]="!isValid() || showErrorMessage()"
      >
        Avanti >>
    </button>
  </div>

</section>




